import { CompanyAddressStore } from "services/companyAddress/au/companyAddressStore";
import { CompanyAddressFormStoreBase } from "services/companyAddressForm/companyAddressFormStoreBase";

export class CompanyAddressFormStore extends CompanyAddressFormStoreBase {
  constructor(protected readonly _companyAddressStore: CompanyAddressStore) {
    super(_companyAddressStore);
  }
}
